import type { Pathways_StackingType as StackingType } from '__generated__/graphql-types';

import { getUpsellCopy } from 'bundles/stackability-common';

const getPathwayUpsellCaption = (degreeStackingType: StackingType) => {
  const upsellCopy = getUpsellCopy().homepagesNavXdp;
  switch (degreeStackingType) {
    case 'PART_OF':
      return upsellCopy.buildTowardADegree;
    case 'OFFERS_CREDIT':
      return upsellCopy.earnDegreeCredit;
    default:
      return upsellCopy.prepareForADegree;
  }
};

export default getPathwayUpsellCaption;
